import axios from "axios";
import prizeo from "../../router/prizeo";
import country_list from "../../locales/country_list.json";
import $ from "jquery";

const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();

const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("lang_prizeo");

if(language =='ms'){
  brwlang ='malay';
}else if(language =='ar'){
  brwlang ='arabic';
}else if(language =='el'){
  brwlang ='greek';
}else if(language =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(language =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(language =='id'){
  brwlang ='indonesian';
}else if(language =='th'){
  brwlang ='thai';
}else if(language =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(language =='en'){
  brwlang ='english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = ''

if (type == true) {
    gcid = parts[1]
} else {
    gcid = ''
}

const state = {
  live: `http://cook.grabmobi.com`,
  local: `http://[::1]/PuretechGlobalContentPortal`,
  proxyurl: `http://api.allorigins.win/get?url=`,
  //allsubcategory
  allsubcategory_prizeo: {},
  //auth
  auth_prizeo: "",
  //hotpicks.vue
  pageHP_prizeo: {},
  //popular.vue
  pagePop_prizeo: {},
  //notification.vue
  notification_prizeo: {},
  //icon
  hotpickIcon_prizeo: require(`../../assets/prizeo/imgs/other/Hot Picks.svg`),
  popularIcon_prizeo: require(`../../assets/prizeo/imgs/other/Populars.svg`),
  langButton_prizeo: ``,
  country_prizeo: parts[0],
  host_prizeo: host,
  // lang_prizeo: localStorage.getItem("lang_prizeo"),
  lang_prizeo: brwlang,
  type: 'browse',
  gcid_prizeo: gcid,
  hpisLoad_prizeo: false,
  renew_date_prizeo: '',
  subscription_date_prizeo: '',
  msisdn_prizeo: '',
  country_name_prizeo: '',
  gateway_prizeo: '',
  is_unsub: '0',
};

const getters = {
  langButton_prizeo: state => state.langButton_prizeo,
  lang_prizeo: state => state.lang_prizeo,
  gcid_prizeo: state => state.gcid_prizeo,
  country_prizeo: state => state.country_prizeo,
  allSubcategory_prizeo: state => state.allsubcategory_prizeo,
  pageHotPicks_prizeo: state => state.pageHP_prizeo,
  pagePopular_prizeo: state => state.pagePop_prizeo,
  HotPickIcon_prizeo: state => state.hotpickIcon_prizeo,
  PopularIcon_prizeo: state => state.popularIcon_prizeo,
  notification_prizeo: state => state.notification_prizeo,
  host_prizeo: state => state.host_prizeo,
  auth_prizeo: state => state.auth_prizeo,
  hpisLoad_prizeo: state => state.hpisLoad_prizeo,
  renew_date_prizeo: state => state.renew_date_prizeo,
  subscription_date_prizeo: state => state.subscription_date_prizeo,
  msisdn_prizeo: state => state.msisdn_prizeo,
  country_name_prizeo: state => state.country_name_prizeo,
  gateway_prizeo: state => state.gateway_prizeo,
  is_unsub_prizeo: state => state.is_unsub,
};

const actions = {
  async fetchLocale_prizeo({ commit }, lang) {
    for (let [key, value] of Object.entries(country_list)) {
      if(lang == value.language){
        lang = value.language
      }else{
        //english
        lang = lang
      }
    }
    
    commit("setLanguage", lang);
  },
  async fetchTranslateButton_prizeo({commit}, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if(country == key){
        let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
        <img lang="${value.language}" src="${value.flag_rec}" />
        <span lang="${value.language}">${value.button_text}</span>
        </button>`

        commit("setButton", button);
      }
    }
  },
  async fetchAllSubcategory_prizeo({commit}, subcategory){
    //to get the subcategory translation
    let subcateg = await axios.get(
      `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${subcategory}&limit=1&offset=0&domain=${host}`
    );
    
    commit("setAllSubcategory", subcateg.data.data);
  },
  async fetchHotPicks_prizeo({ commit }) {
    // let month = currentDate.getUTCMonth();
    let w = week % 2;

    let browseCat = [];
    let browseCategory = [];
    let allDataContent = [];
    let allData = [];

    let allcontent= await axios.get(
      `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=&limit=400&offset=0&domain=${host}`
    );

    if(w == 0){
      allcontent.data.data.sort((a, b) => a.content_name.localeCompare(b.content_name))
    }else{
      allcontent.data.data.sort((a, b) => b.content_name.localeCompare(a.content_name))
    }
    
    let browse = await axios.get(
      `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=browse&subcategory=&limit=100&offset=0&domain=${host}`
    );
    
    allDataContent = allcontent.data.data;
    browseCat = browse.data.data;
    
    let isload = '';
    browseCat.map((item)=>{
      let trans = JSON.parse(item.category_translate);
      if (trans != null) {
        let trans_len = Object.keys(trans).length;
        let trans_arr = Object.keys(trans);
        for (let i = 0; i < trans_len; i++) {
            item["title_" + trans_arr[i]] = trans[trans_arr[i]].title;
        }
      }
      browseCategory.push(item)
      
      let count = 0;
      let category = item.category;
      allData[category] = new Array()
      allDataContent.map((item2)=>{
        if(item2.category == item.category){
          if(count< 6){
            allData[category].push(item2)
            count++;
          }
          isload = true;
        }
      })
    })
    
    commit("setHotPicks", { browseCategory, allData, isload });
  },
  async fetchPopular_prizeo({ commit }) {
    let response = await axios.get(
      `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=&limit=10&offset=10&domain=${host}`
    );

    response.data.data.sort(function(a, b) {
      //to sort random
      return 0.5 - Math.random();
    });

    commit("setPopular", response.data.data);
  },
  async fetchPageHotPicks_prizeo({ commit }, file) {
    let data = file[0]

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = []

    if(data == undefined){
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
      );
    }else{
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    response.data.data.sort((a,b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    )

    // console.log(response.data.data);

    commit("setPageHotPicks", response.data.data);
  },
  async fetchPagePopular_prizeo({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = await axios.get(
      `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
    );

    response.data.data.sort((a,b) =>
      // a.content_name.localeCompare(b.content_name),
      b.rating - a.rating
    )

    commit("setPagePopular", response.data.data);
  },
  async fetchToken_prizeo({ commit, dispatch }, id) {
    let auth = "";
    let check = "";

    let token = localStorage.getItem("userToken_prizeo");
    let userProfile = localStorage.getItem("userProfile_prizeo");

    let str = window.location.pathname;
    let path = str.split("/");
    path.pop();
    path = path.join('/');

    if(path == ''){
      path = '/home';
    }
    
    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }
    
    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkToken_prizeo", auth);
      // console.log(check)
      auth = auth.toLowerCase();
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (auth.match(letterNumber)) {
        check = true
      } else {
        check = false
      }
    } else {
      prizeo.push({ name: "Login" }).catch(err => {});
    }
    
    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };

      if (token != null) {
        localStorage.setItem("userToken_prizeo", data.code);
        commit("setUserProfile", JSON.parse(userProfile));
        commit("setAuth", "loggedin");
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        let responses = await axios.post(
          `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
        );
        var response = JSON.parse(responses.data.contents);
        if (response.status == "active") {
          localStorage.setItem("userToken_prizeo", data.code);
          localStorage.setItem("userProfile_prizeo",responses.data.contents)
          commit("setUserProfile", response);
          commit("setAuth", "loggedin");
          prizeo.push({ path: path }).catch(err => {});
          // location.reload();
        } else if (response.status == "inactive") {
          if(data.code != undefined){
            alert(response.status.toUpperCase())
          }
          prizeo.push({ name: "Login" }).catch(err => {});
        }
      }
    } else {
      //if check is false
      prizeo.push({ name: "Login" }).catch(err => {});
    }
  },
  async getDomain_prizeo({ commit }, host){
    let response = await axios.get(`${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`);

    let dom= response.data.data
    dom = dom.filter(item =>{
      return item.domain == host;
    })

    let domain = ""

    if(dom != ""){
      domain = dom[0].is_unsub;

      if(dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id)
    }else{
      domain = '0'
    }
    commit("setUnsubButton", domain);
  },
  async checkToken_prizeo({ commit }, auth) {
    var letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subContent_prizeo({ commit }, file) {
    let token = localStorage.getItem("userToken_prizeo");
    let lang = localStorage.getItem("lang_prizeo");
    let alert_pop = "";
    
    let alert_lang = require(`../../locales/prizeo/${lang}.json`);
    alert_pop = alert_lang.not_subs;
    
    if (token != null) {
      if (file[1] != 'application/x-zip-compressed') {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_prizeo,
          product: 'prizeo',
          content_id: file[2],
          type: "download"
        })

        window.open(file[0], "download");
      } else {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_prizeo,
          product: 'prizeo',
          content_id: file[2],
          type: "play"
        })

        window.open(file[0], "_blank");
      }
    } else {
      alert(alert_pop);

      setTimeout(() => {
        prizeo.push({ name: "Login" }).catch(err => {});
      }, 1000);
    }
  },
  async login_prizeo({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_prizeo({ commit }) {
    let notify =[]
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if(w != 0){
      date = date + 10
    }
    
    let res = await axios.get(
      `${state.live}/api/contents/newcontents_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=${host}`
    );

    let data = res.data.data;
    let noti = data.map((noti) =>{
      noti.titleSub_english = noti.subcategory
      if(noti.subcategory_translate != null){
        let sub_trans = JSON.parse(noti.subcategory_translate)
        if(sub_trans != null){
          let trans_len = Object.keys(sub_trans).length
          let trans_arr = Object.keys(sub_trans)
          
          if(sub_trans != null || sub_icon != null){
            for(let i = 0; i<trans_len; i++){
                noti['titleSub_'+trans_arr[i]] = sub_trans[trans_arr[i]].title
            }
          }
        }
      }
      return noti;
    })

    // if(w == 0){
    //   //name ascending
    //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
    // }else{
    //   //name descending
    //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
    // }

    // notify = noti.slice(0,5);

    commit("setNotification", noti);
  },
  async logout_prizeo({commit}, is_unsub){
   
    if(is_unsub != '0'){
      let token = localStorage.getItem("userToken_prizeo")
      let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_name_prizeo}/${state.gateway_prizeo}/unsub.php?code=${token}&msisdn=${state.msisdn_prizeo}`));
      removeStorage()
      $("#exampleModalCenter").modal("hide");
      var response = JSON.parse(responses.data.contents); 
      if(responses.data.contents == 'success' || response.status =='success'){
        if (state.country_prizeo == 'iq' || state.gcid_prizeo =='289'||state.gcid_prizeo =='290' || state.gcid_prizeo =='291' || state.gcid_prizeo =='308') {
          prizeo.push({ name: 'Unsubscription'}).catch(err => {});
        } else {
          prizeo.push({ name: 'Login'}).catch(err => {});
        }
      }
    }else{
      removeStorage();
      if (state.country_prizeo == 'iq' || state.gcid_prizeo =='289'||state.gcid_prizeo =='290' || state.gcid_prizeo =='291') {
        $("#exampleModalCenter").modal("hide");
        prizeo.push({ name: 'Unsubscription'}).catch(err => {});
      } else {
        prizeo.push({ name: 'Login'}).catch(err => {});
      }
    }

    function removeStorage(){
      localStorage.removeItem("userProfile_prizeo");
      localStorage.removeItem("userToken_prizeo");
      localStorage.removeItem("logged-in");
      commit("setAuth", "");
    } 
    
  }
};

const mutations = {
  setHotPicks: (state, response) => (
    (state.hotpicksCategory_prizeo = response.browseCategory),
    (state.hotpicksData_prizeo = response.allData),
    (state.hpisLoad_prizeo = response.isload)
  ),
  setPopular: (state, response) => (state.popular_prizeo = response),
  setPageHotPicks: (state, response) => (state.pageHP_prizeo = response),
  setPagePopular: (state, response) => (state.pagePop_prizeo = response),
  setNotification: (state, response) => (state.notification_prizeo = response),
  setAuth: (state, response) => (state.auth_prizeo = response),
  setButton: (state, response) => (state.langButton_prizeo = response),
  setLanguage: (state, response) => (state.lang_prizeo = response),
  setAllSubcategory: (state, response) => (state.allsubcategory_prizeo = response),
  setUserProfile: (state, response) => (
    state.renew_date_prizeo = response.next_renew_date,
    state.subscription_date_prizeo = response.subscription_date,
    state.msisdn_prizeo = response.msisdn,
    state.country_name_prizeo = response.country_code,
    state.gateway_prizeo = response.gateway_code
  ),
  setGatewayID: (state, response) =>(
    state.gcid_prizeo = response
  ),
  setUnsubButton: (state, response) => (
    state.is_unsub = response
  )
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/prizeo-store.js